import {Injectable} from "@angular/core";
import {HttpClient, HttpParams} from "@angular/common/http";
import {env} from "@environments/environment";
import {Observable} from "rxjs";
import {PageModel} from "@app/models/page.model";
import {GoodSpecificationsResponse} from "@app/ui_models/web-response";
import {map} from "rxjs/operators";

@Injectable({ providedIn: "root" })
export class PostponeController {

  public constructor(httpService: HttpClient) {
    this.httpService = httpService;
  }

  httpService: HttpClient;

  protected baseUrl = `${env.logisticsServiceBackend}/logistics/v1/postponed`;

  public getPostponedSpecifications(params: HttpParams): Observable<PageModel<GoodSpecificationsResponse>> {
    return this.httpService.get(`${this.baseUrl}`, { params, responseType: "text" }).pipe(map(res => (res ? JSON.parse(res) : undefined)));
  }

}
